// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 329 ? "88a4ce8c" : chunkId) + "." + {"329":"08cd8cc560f140d8","374":"122d501e6a842f8d","430":"10298c9a1407228a"}[chunkId] + ".js";
};